// extracted by mini-css-extract-plugin
module.exports = {"heading":"index-module--heading--366wl","content":"index-module--content--1b3LS","map":"index-module--map--j-FID","form":"index-module--form--O9Oyj"};